var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap" }, [
      _c("header", { staticClass: "header header--detail" }, [
        _c("div", { staticClass: "header__container" }, [
          _c("div", { staticClass: "header__row" }, [
            _c("a", {
              staticClass: "prev prev--white",
              attrs: { href: "/myprotein-result", "aria-label": "이전" }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contents" }, [
        _c(
          "div",
          { staticClass: "contents__contents contents__contents--overlap" },
          [
            _c("div", { staticClass: "protein-detail table" }, [
              _c("div", { staticClass: "table__group" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v("식품 100g당 단백질 함량")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "desc" }, [_vm._v("식물성 단백질")]),
                _vm._v(" "),
                _c("table", { staticClass: "table__table" }, [
                  _c("colgroup", [
                    _c("col", { staticStyle: { width: "21%" } }),
                    _vm._v(" "),
                    _c("col"),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "25%" } }),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "25%" } })
                  ]),
                  _vm._v(" "),
                  _c("thead", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "col" } }, [_vm._v("식품군")]),
                      _vm._v(" "),
                      _c("th", { attrs: { scope: "col" } }, [_vm._v("식품명")]),
                      _vm._v(" "),
                      _c("th", { attrs: { scope: "col" } }, [
                        _vm._v("단백질(g)")
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { scope: "col" } }, [_vm._v("kcal")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "row", rowspan: "5" } }, [
                        _c("img", {
                          attrs: {
                            src: require("./assets/images/ico/ico_protein01.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t곡류\n\t\t\t\t\t\t\t\t\t")
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("백미밥")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("3")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("152")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("현미밥")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("3.3")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("167")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("오트밀")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("13.2")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("382")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t메밀 국수"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(삶은것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("4.28")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("114")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t찰 옥수수"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(삶은것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("4.22")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("140")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("th", { attrs: { scope: "row", rowspan: "2" } }, [
                        _c("img", {
                          attrs: {
                            src: require("./assets/images/ico/ico_protein02.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t두류\n\t\t\t\t\t\t\t\t\t")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t강낭콩"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(삶은것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("8.46")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("170")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t서리태"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(삶은것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("19.02")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("196")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row", rowspan: "5" } }, [
                        _c("img", {
                          attrs: {
                            src: require("./assets/images/ico/ico_protein03.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t채소류\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t브로콜리"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(삶은것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("3.5")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("27")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t케일"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(생것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("3.5")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("27")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t콩나물"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(삶은것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("4.52")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("33")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t시금치"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(데친것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("3.4")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("23")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t느타리버섯"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(데친것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("3.26")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("21")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("th", { attrs: { scope: "row", rowspan: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require("./assets/images/ico/ico_protein04.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t견과류\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t밤"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(삶은것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("3.45")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("154")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t땅콩"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(삶은것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("13.5")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("318")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t아몬드"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(볶은것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("23.45")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("594")])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table__group" }, [
                _c("p", { staticClass: "desc" }, [_vm._v("동물성 단백질")]),
                _vm._v(" "),
                _c("table", { staticClass: "table__table" }, [
                  _c("colgroup", [
                    _c("col", { staticStyle: { width: "21%" } }),
                    _vm._v(" "),
                    _c("col"),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "25%" } }),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "25%" } })
                  ]),
                  _vm._v(" "),
                  _c("thead", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "col" } }, [_vm._v("식품군")]),
                      _vm._v(" "),
                      _c("th", { attrs: { scope: "col" } }, [_vm._v("식품명")]),
                      _vm._v(" "),
                      _c("th", { attrs: { scope: "col" } }, [
                        _vm._v("단백질(g)")
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { scope: "col" } }, [_vm._v("kcal")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "row", rowspan: "6" } }, [
                        _c("img", {
                          attrs: {
                            src: require("./assets/images/ico/ico_protein05.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t육류\n\t\t\t\t\t\t\t\t\t")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t닭고기"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(삶은것,살코기)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("27.8")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("143")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t오리고기"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(생것,껍질포함)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("16.63")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("242")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t돼지 목심"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(구운것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("24.06")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("258")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t돼지 삼겹살"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(구운것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("22.78")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("469")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t한우 안심"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(생것,1등급)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("19.17")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("200")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t한우 꽃등심"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(생것,1등급)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("17.76")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("326")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("th", { attrs: { scope: "row", rowspan: "2" } }, [
                        _c("img", {
                          attrs: {
                            src: require("./assets/images/ico/ico_protein06.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t난류\n\t\t\t\t\t\t\t\t\t")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t삶은"),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t달걀\n\t\t\t\t\t\t\t\t\t")
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("13.94")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("143")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t삶은"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t메추리알\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("12.48")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("155")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row", rowspan: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require("./assets/images/ico/ico_protein07.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t어패류 외\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t광어"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(생것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("22.36")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("125")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t오징어"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(생것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("18.84")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("94")])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t새우-대하"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t(생것)\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("18.1")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("83")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("th", { attrs: { scope: "row", rowspan: "4" } }, [
                        _c("img", {
                          attrs: {
                            src: require("./assets/images/ico/ico_protein08.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v("\n\t\t\t\t\t\t\t\t\t\t우유 및"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t유제품류\n\t\t\t\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("저지방우유")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("3.43")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("42")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("td", [_vm._v("(떠먹는)요구르트, 플레인")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("5.18")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("89")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("td", [_vm._v("모짜렐라 치즈")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("28.02")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("294")])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "fill" }, [
                      _c("td", [_vm._v("체다 치즈")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("18.76")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("298")])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "etc" }, [
                _vm._v("출처: 국가표준식품성분표(9개정판)")
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45bf404a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45bf404a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/myproteinDetail.vue
// module id = null
// module chunks = 